module.exports = __webpack_public_path__ + "static/logo_fischer_marmor_website.0159034d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_fischer_marmor_website.png
// module id = 257
// module chunks = 114276838955818